import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

class ScrollToTop extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    children: PropTypes.node,
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.action === 'REPLACE') {
      return
    }

    // Scroll to top for path name changes and not for query param and hash changes
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children || null
  }
}

export default withRouter(ScrollToTop)
